
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ErrorNotification from "./ErrorNotification.vue";
import moment from "moment";
import Detail from "./Detail.vue";
const profile = namespace("profile");
const schedule = namespace("schedule");
const notification = namespace("notification");
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import bus from '../../eventBus';
import { useAppInsights } from '../../store/modules/AppInsights'

@Component({
    components: {
            Detail,
            ErrorNotification,
            Loading
        },
    })
export default class RequestedTrade extends Vue {
  data= {
    tradeDetail: {} as any,
    loadedDetail: false
  }
  showErrorMsg: boolean = false;
    errorMsg: string = '';
    errorType: string = 'error';
  @Prop() currentEvent: any;
  disableAll: boolean= false;
  @schedule.State shiftTradeOfferDetail!: any;
  @schedule.State public assignmentDetail!: any;
  isLoading:boolean = false;
  loaderColor: string = "#0085ca";
  @profile.State public profileData!: any;
    @profile.State
    isImpersonating!: boolean;

  @notification.State public notificationList!: any;
  @profile.State
  appInsightEventData!: any;
  
 $refs!: {            
    Detail:any;
  };
  async mounted() {
    this.getShiftTradeOffer();
  }

  getShiftTradeOffer() {            
    var payload = { 
      username: this.profileData.username, 
      shiftTradeOfferId: this.currentEvent.id,
    };

    this.$store
      .dispatch("schedule/getShiftTradeRequested", payload)
      .then((res: any) => {
        this.data.tradeDetail = res;
        this.data.loadedDetail = true;
        if(res.status === 'Accepted') {
          this.disableAll = true;
        }
      })
      .catch((err: any) => {
        if (err) {
          console.log(err); // Handle errors any way you want
          let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;                             
          this.showErrorMsg = true;                            
          this.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
        }        
      });
  }

  fireAction(type: string): void {
      const requestBody = [{
          id: this.currentEvent.id,
          username: this.data.tradeDetail.username,
          firstName: this.data.tradeDetail.firstName,
          lastName: this.data.tradeDetail.lastName,
          tenantId: this.data.tradeDetail.tenantId,
          scheduleId: this.data.tradeDetail.scheduleId,
          facilityId: this.data.tradeDetail.facilityId,
          coid: this.data.tradeDetail.coid,
          facilityName: this.data.tradeDetail.facilityName,
          departmentId: this.data.tradeDetail.departmentId,
          // facilityCoId: this.assignmentDetail.facilityCoId,
          departmentName: this.data.tradeDetail.departmentName,
          departmentCode:  this.data.tradeDetail.departmentCode,
          departmentShiftId: this.data.tradeDetail.departmentShiftId, // todo not sure of value
          shiftCode: this.data.tradeDetail.shiftCode,
          shiftDescription: this.data.tradeDetail.shiftDescription,
          skill: this.data.tradeDetail.skill,
          date: this.data.tradeDetail.date,
          startTime: this.data.tradeDetail.startTime,
          endTime: this.data.tradeDetail.endTime,
          actualStartTime: this.data.tradeDetail.actualStartTime,
          actualEndTime: this.data.tradeDetail.actualEndTime,
          hours: this.data.tradeDetail.hours,
          minutes: this.data.tradeDetail.minutes,
          status: "",
          requestorAssignmentId: this.data.tradeDetail.requestorAssignmentId,
          acceptorAssignmentId: this.data.tradeDetail.acceptorAssignmentId,
          offeredToUsername: this.data.tradeDetail.offeredToUsername,
          offeredToFirstName: this.data.tradeDetail.offeredToFirstName,
          offeredToLastName: this.data.tradeDetail.offeredToLastName,
          isAutoapprovable: this.data.tradeDetail.isAutoapprovable,
          notificationId: null,
          productiveType: this.data.tradeDetail.productiveType
      }];
      requestBody[0].status = type === "deny" ? 'Rejected' : 'Accepted';

      //get Notification Id
      var notification = this.notificationList.filter((notify) => notify.shiftTradeOfferId == this.currentEvent.id);
      if(notification != undefined && notification.length > 0){
        requestBody[0].notificationId = notification[0].id;
      }

      this.isLoading = true;
      this.$store
        .dispatch("schedule/acceptShiftTradeOffer", requestBody)
        .then(() => {
          this.isLoading = false;
          this.$emit('showSuccessMsgPopUp', true);
          this.$emit('closeSharedModal');
          bus.$emit('shiftTradenotificationchanged');
        })
        .catch((err: any) => {
          this.isLoading = false;
          this.$emit('showSuccessMsgPopUp', false);
          let parseResponse = err.request.responseText;                            
          this.showErrorMsg = true;                            
          this.errorMsg = (parseResponse != null || parseResponse != undefined) ? parseResponse : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
          bus.$emit('shiftTradenotificationchanged');
        });
  }
  get getDept() {
            return this.data.tradeDetail.departmentName + " (" + this.data.tradeDetail.departmentCode + ")";
        }

  formatDate(date: Date): string {
    return moment(date).format("ddd, MMM D");
  }

  formatDateShift(date: Date): string {
    return moment(date).format('dddd MMMM D yy');
  }

    formatTime(t: Date): string {
    return moment(t).format("h:mm A");
  }
}
